import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query GetChannelsGroupPagination($page: Int, $pageSize: Int) {
  channelsGroupsPagination(page: $page, pageSize: $pageSize) {
    channelsGroups {
      id
      name
      description
      config
      channels {
        id
        name
      }
      groupUsers {
        id
      }
    }
    totalCount
    pageSize
  }
}`;

function getChannelsGroupsPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => (res.data.channelsGroupsPagination))
    .then(({ channelsGroups, totalCount, pageSize: pageSizeDefault }) => ({
      channelsGroups: channelsGroups.map((channelsGroup) => ({
        ...channelsGroup,
        config: JSON.parse(channelsGroup.config),
      })),
      totalCount,
      pageSizeDefault,
    }));
}

export default getChannelsGroupsPagination;
